class numSequence {
  constructor(id) {
    this.id = id;
  }
  static fromJson({ numSecuencia }) {
    return new numSequence(numSecuencia);
  }
}
export default numSequence;
